import { render, staticRenderFns } from "./IconDatabaseSolid.vue?vue&type=template&id=3de34b04"
import script from "./IconDatabaseSolid.vue?vue&type=script&lang=js"
export * from "./IconDatabaseSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports